export default {"src":"/_next/static/media/Featured.089fe3c3.svg","height":56,"width":56};